import './src/styles/styles.less';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import type { GatsbyBrowser } from 'gatsby';

// GPC banner: show when browser sends Global Privacy Control signal
function initGpcBanner(): void {
	const nav = navigator as Navigator & { globalPrivacyControl?: boolean };
	if (typeof navigator === 'undefined' || nav.globalPrivacyControl !== true) return;

	const renderBanner = (): void => {
		if (document.getElementById('gpc-banner')) return;

		const banner = document.createElement('div');
		banner.id = 'gpc-banner';
		Object.assign(banner.style, {
			position: 'fixed',
			bottom: '10px',
			left: '10px',
			backgroundColor: '#333',
			color: 'white',
			padding: '10px 20px',
			borderRadius: '5px',
			fontSize: '14px',
			zIndex: '10000'
		});
		banner.innerHTML = 'GPC Signal Recognized and Honored';
		document.body.appendChild(banner);
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', renderBanner);
	} else {
		renderBanner();
	}
}

// Accessibility
export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
	initGpcBanner();

	const s = document.createElement('script'),
		e = !document.body ? document.querySelector('head') : document.body;
	s.src = 'https://acsbapp.com/apps/app/assets/js/acsb.js';
	s.async = s.defer = true;
	s.onload = function () {
		window.acsbJS.init({
			statementLink: '',
			feedbackLink: '',
			footerHtml: '',
			hideMobile: false,
			hideTrigger: false,
			language: 'en',
			position: 'right',
			leadColor: '#146FF8',
			triggerColor: '#146FF8',
			triggerRadius: '50%',
			triggerPositionX: 'right',
			triggerPositionY: 'bottom',
			triggerIcon: 'default',
			triggerSize: 'medium',
			triggerOffsetX: 20,
			triggerOffsetY: 20,
			mobile: {
				triggerSize: 'small',
				triggerPositionX: 'right',
				triggerPositionY: 'center',
				triggerOffsetX: 0,
				triggerOffsetY: 0,
				triggerRadius: '50%'
			}
		});
	};
	e.appendChild(s);
};
